// removed by extract-text-webpack-plugin
module.exports = {"component":"_1hG-RQ1g2Qn4t_lMDhsihE","instructions":"qoEtViPPsmo9H9aDYrJMM"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FormElements/Instructions/Instructions.css
// module id = 1362
// module chunks = 0